import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Box } from "@flukecorp-emu/common-ui";

export const Route = createRootRouteWithContext()({
  component: () => {
    return (
      <Box
        sx={{
          backgroundColor: "#F8F8F8 !important",
        }}
        data-testid="root-layout"
      >
        <Outlet />
      </Box>
    );
  },
});
